import { Controller } from '@hotwired/stimulus';
import { createFocusTrap } from 'focus-trap';

import.meta.stimulusFetch = 'lazy';

export default class extends Controller {
    static targets = ['dialog', 'actions'];

    static values = {
        bodyScroll: { type: Boolean, default: true },
        backdropClose: { type: Boolean, default: true },
    };

    initialize() {
        this.trap = createFocusTrap(this.dialogTarget);

        if (!this.bodyScrollValue) {
            document.body.classList.add('has-[dialog[open],[data-dialog-body-scroll="false"]]:tw-container-type-normal');
            document.body.classList.add('has-[dialog[open],[data-dialog-body-scroll="false"]]:tw-overflow-hidden');
        }
    }

    open() {
        this.dialogTarget.showModal();
        this.trap.activate();
    }

    close() {
        this.dialogTarget.close();
        this.trap.deactivate();
    }

    confirm() {
        this.close();
    }

    backdropClose(event) {
        if (this.backdropCloseValue && event.target === this.dialogTarget) {
            this.close();
        }
    }
}
